import types from './RequestHistoryActionType';

export default class RequestHistoryActionTitle {
    static [types.CLOSED] = 'Закрыл(а) обращение';
    static [types.DENIED] = 'Отказал(а) в обращении';
    static [types.PAUSED] = 'Приостановил(а) обращение';
    static [types.REWORK] = 'Отправил(а) обращение на уточнение';
    static [types.WORKUP] = 'Вернул(а) обращение в работу';
    static [types.FINISH] = 'Выполнил(а) обращение';
    static [types.CHANGE_EXECUTOR] = 'Изменил(а) исполнителя обращения на <span class="hl1">{_executor_}</span>';
    static [types.CHANGE_SECURITY_GROUP] = 'Изменил(а) группу исполнителей на <span class="hl1">{_executor_}</span>';
    static [types.CREATED] = 'Создал(а) обращение';
    static [types.COMMENTED] = 'Прокомментировал(а) обращение';
    static [types.SYSTEM_CLOSED] = 'Закрыл(а) обращение';
    static [types.SERVICE_CHANGED] = 'Изменил(а) категорию/сервис обращения';
    static [types.WATCHED] = 'Посмотрел(а) обращение';
    static [types.PRIORITY_CHANGED] =
        'Изменил(а) приоритет обращения: <span class="hl1">{_oldPriority_}</span> → <span class="hl1">{_newPriority_}</span>';
    // {_parentRequest_} — номер главного обращения. Пользователю бэкенд meta не отдаёт,
    // и подпись остаётся анонимной.
    static [types.PARENT_REQUEST_LINKED] = 'Связал(а) обращение с массовой проблемой{_parentRequest_}';
    static [types.PARENT_REQUEST_UNLINKED] = 'Отвязал(а) обращение от массовой проблемы{_parentRequest_}';
}
